import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ImageLandingPageConverter extends CmsConverterService<ImageLandingPageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_image_normal_title_text?.value
    const altText = formData.st_image_normal_alternative_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      overlayCaption: formData.st_modal_headline ?? defaultTextInput,
      overlayDescription: formData.st_modal_text ?? defaultTextInput,
      captionBGColor: formData.st_caption_backgroundcolor?.value?.identifier ?? '',
      image: CmsConverterService.mapImage(formData.st_image_normal_reference, lazyLoad, altText, title),
      caption: formData.st_caption_text ?? defaultTextInput,
      enableCaption: formData.st_enable_caption?.value ?? false,
      hideImageModal: formData.st_hide_image_modal?.value ?? false
    }
  }
}

export const IMAGE_LANDING_PAGES_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ImageLandingPageData>>(
  'ImageLandingPageConverter')

export interface ImageLandingPageData extends ConvertedComponentData {
  overlayCaption: TextInput;
  overlayDescription: TextInput;
  captionBGColor: string;
  image: Image;
  caption: TextInput;
  enableCaption: boolean;
  hideImageModal: boolean;
}
